import {Professions} from 'Models'

export default {
    computed: {
        isProfessionTypeTest() {
            return Professions.getSelected().testIntro() ? Professions.getSelected().testIntro().profession_type === 'berufswahltest' : false
        },
    },
}